module.exports = __webpack_public_path__ + "img/SJZT.cfc50f47.svg";